import { Injectable } from '@angular/core';
import { EHosts } from "libraries/enums/EHosts";
import { IRejectFareOptimisationRequestParams } from "libraries/service/booking/enums/fare-optimisation";
import { DummyCheckboxService } from "libraries/dummyCheckbox/dummyCheckbox.service";

@Injectable()
export class FareOptimisationRequesterService {

    constructor(
        private readonly dummyCheckboxService: DummyCheckboxService
    ) {
    }

    public createRejectFareOptimisationRequest(
        syscode: string,
        host: EHosts,
        priceQuotationTypeReference: string,
        priceStoredFareTypeReference: string,
        rejectionReasonCode: string,
        rejectionType: string,
        otherReason: string,
        fixedDate: string,
        nbDays: number,
        countingFrom: string): IRejectFareOptimisationRequestParams {
        return {
            host,
            syscode,
            dummy: this.dummyCheckboxService.isDummy,
            priceQuotationTypeReference,
            priceStoredFareTypeReference,
            rejectionReasonCode,
            rejectionType,
            otherReason,
            fixedDate,
            nbDays,
            countingFrom
        };
    }

}
